var map = {
	"./watch_bear0.png": "gPnR",
	"./watch_bear1.png": "dfux",
	"./watch_bear10.png": "1f/W",
	"./watch_bear11.png": "Eexw",
	"./watch_bear12.png": "I2E1",
	"./watch_bear13.png": "q64/",
	"./watch_bear14.png": "NghZ",
	"./watch_bear15.png": "isON",
	"./watch_bear16.png": "7eHa",
	"./watch_bear17.png": "jpvu",
	"./watch_bear18.png": "/MTG",
	"./watch_bear19.png": "rq17",
	"./watch_bear2.png": "OMNb",
	"./watch_bear20.png": "HMuo",
	"./watch_bear3.png": "L69u",
	"./watch_bear4.png": "i+6c",
	"./watch_bear5.png": "ylSJ",
	"./watch_bear6.png": "6fOi",
	"./watch_bear7.png": "8Ae4",
	"./watch_bear8.png": "xQ36",
	"./watch_bear9.png": "5lfC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6/Q";


//////////////////
// WEBPACK FOOTER
// ./src/components/portal-bear/images/animation/watch ^\.\/watch_bear.*\.png$
// module id = b6/Q
// module chunks = 12